import { z } from 'zod';

export const updateProfileSchema = z.object({
  first_name: z.string().min(1, { message: 'First name is required' }),
  last_name: z.string().min(1, { message: 'Last name is required' }),
  phone_number: z.string().optional(),
  email: z.string().email({ message: 'Invalid email address' }).optional(),
  dob: z.string().min(1, { message: 'Date of birth is required' }),
  experience: z.number().nullable().optional(),
  avatar: z.instanceof(File).nullable().optional().or(z.literal('')),
});

export type UpdateProfileFormValues = z.infer<typeof updateProfileSchema>;
